export const DESKTOP_BREAKPOINT = 1280;
export const TABLET_BREAKPOINT = 960;
export const TABLET_PORTRAIT_BREAKPOINT = 670;

// _TODO: Hardcode - минимальный процент для первого взноса в калькуляторе
export const MIN_PAYMENT = 15;
